/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import { connect } from 'react-redux';
import { Progress } from 'antd';
import { Loading, Page } from '~/components';
import { MenuService, PrincipalService } from '~/services';
import './PrincipalPage.less';
import { decimalPlace } from '~/utils';

class PrincipalPage extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      isLoadingPreco: false,
      isLoadingContato: false,
      dataItemsFinanceiro: [],
      dataItemsPreco: [],
      dataItemsContato: [],
      dataItemsRecado: [],
    };
  }

  componentDidMount() {
    this.buscarPreco();
    this.buscarFinanceiro();
    this.buscarRecado();
    this.buscarContato('PRINCIPAL');
  }

  buscarPreco = () => {
    const { user } = this.props;

    this.setState({ isLoadingPreco: true }, () => {
      PrincipalService.getAll(
        user.codigo,
        dataItemsPreco => this.setState({ dataItemsPreco, isLoadingPreco: false }),
        () => this.setState({ dataItemsPreco: [], isLoadingPreco: false })
      );
    });
  };

  buscarContato = arquivo => {
    this.setState({ isLoadingContato: true }, () => {
      PrincipalService.getAllContato(
        arquivo,
        response =>
          this.setState({ dataItemsContato: response.map(item => ({ ...item, zap: item.telefone.replace(/[^0-9]/g, '') })), isLoadingContato: false }),
        () => this.setState({ dataItemsContato: [], isLoadingContato: false })
      );
    });
  };

  buscarFinanceiro = () => {
    const { user } = this.props;

    PrincipalService.getAllFinanceiro(
      user.codigo,
      dataItemsFinanceiro => this.setState({ dataItemsFinanceiro }),
      () => this.setState({ dataItemsFinanceiro: [] })
    );
  };

  buscarRecado = () => {
    const { user } = this.props;

    PrincipalService.getAllRecado(
      user.codigo,
      dataItemsRecado => this.setState({ dataItemsRecado }),
      () => this.setState({ dataItemsRecado: [] })
    );
  };

  render() {
    const { tabId, user } = this.props;
    const { isLoadingPreco, isLoadingContato, dataItemsPreco, dataItemsContato, dataItemsFinanceiro, dataItemsRecado } = this.state;
    const nomeEmpresa = user.nome ? user.nome.split(' ') : '';
    let limite = '';
    let percentual = 0;
    let textoDisponivel = '';
    let textoUtilizado = '';
    if (dataItemsFinanceiro.length > 0) {
      limite = `Total R$ ${decimalPlace(dataItemsFinanceiro[0].limite_credito, 2)}`;
      textoDisponivel = `R$ ${decimalPlace(dataItemsFinanceiro[0].valor_credito, 2)}`;
      textoUtilizado = `R$ ${decimalPlace(dataItemsFinanceiro[0].valor_aberto, 2)}`;
      // PERCENTUAL DA BARRA - NÃO FORMATAR
      percentual = dataItemsFinanceiro[0].percentual_credito;
    } else {
      limite = <Loading />;
      textoDisponivel = 'Carregando';
      textoUtilizado = 'Carregando';
    }

    return (
      <>
        <Page tabId={tabId} header={null}>
          <div className="conteudo">
            <div className="geral">
              <div className="info">
                <div className="empresa">{`Olá ${nomeEmpresa[0]}!`}</div>
                <div className="texto">
                  <div>Aqui você encontra tudo o que precisa!</div>
                  <div>Seu histórico e relatórios do Financeiro.</div>
                  <div>Emissão de Notas Fiscal e Boletos</div>
                  <div>Ainda pode deixar uma mensagem direta à sua frota!</div>
                  <div />
                </div>

                <div className="contato">
                  Dúvidas entre em contato conosco, pelos whatsapp:
                  {isLoadingContato ? (
                    <Loading />
                  ) : (
                    dataItemsContato.map(item => (
                      <div key={item.idt}>
                        <a href={`https://api.whatsapp.com/send?phone=55${item.zap}`} target="_blank" rel="noopener noreferrer nofollow">
                          {`${item.telefone} ${item.nome}`}
                        </a>
                      </div>
                    ))
                  )}
                </div>
              </div>

              <div className="links">
                <div className="financeiro">
                  <div role="link" className="box_link" onClick={() => MenuService.open(MenuService.getByTitle('Financeiro'), { tab: 'Notas Fiscais' })}>
                    <div className="titulo">
                      <span className="moeda">$</span>
                      Financeiro
                    </div>
                    <div className="subtitulo">
                      <div className="disponivel">
                        <div>{textoDisponivel}</div>
                        <div>Disponível</div>
                      </div>
                      <div className="utilizado">
                        <div>{textoUtilizado}</div>
                        <div>Utilizado</div>
                      </div>
                    </div>
                    <div className="grafico">
                      <Progress
                        type="circle"
                        format={() => limite}
                        percent={percentual}
                        width={250}
                        trailColor="#4190ce"
                        strokeColor="#ef4c6b"
                        gapPosition="top"
                      />
                    </div>
                  </div>
                </div>

                <div className="nota_boleto">
                  <div role="link" className="box_link menor" onClick={() => MenuService.open(MenuService.getByTitle('Financeiro'), { tab: 'cupom' })}>
                    <div className="titulo">Notas Fiscais</div>
                    <div>
                      <img src="/midia/logo_nfe.png" alt="logo_nfe" />
                    </div>
                  </div>
                  <div role="link" className="box_link menor" onClick={() => MenuService.open(MenuService.getByTitle('Financeiro'), { tab: 'boletos' })}>
                    <div className="titulo">Boletos</div>
                    <div className="aviso">EM ABERTO !</div>
                    <div>
                      <img src="/midia/boleto.png" alt="boleto" />
                    </div>
                  </div>
                </div>
              </div>

              {dataItemsRecado.length > 0 ? (
                <div className="informativo">
                  <div className="texto">
                    <div>Atenção Motorista:</div>
                    {dataItemsRecado.map(item => (
                      <div key={item.id}>{item.recado}</div>
                    ))}
                  </div>
                </div>
              ) : (
                ''
              )}
            </div>

            <div className="precos">
              <ul>
                {isLoadingPreco ? <Loading /> : ''}
                {dataItemsPreco.map(item => (
                  <li key={item.idt}>
                    <div className="posto">{item.nome_empresa}</div>
                    <div className="precos-info">
                      <div className="preco-azul">
                        <div className="preco">
                          R$&nbsp;
                          {parseFloat(item.preco_s10)
                            .toFixed(2)
                            .replace('.', ',')}
                        </div>
                        <div className="combustivel">Diesel S10</div>
                      </div>
                      <div className="preco-laranja">
                        <div className="preco laranja">
                          R$&nbsp;
                          {parseFloat(item.preco_s500)
                            .toFixed(2)
                            .replace('.', ',')}
                        </div>
                        <div className="combustivel">Diesel S500</div>
                      </div>
                      <div className="logo-maps">
                        <a
                          href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(item.endereco)}`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img src="/midia/logo_maps.png" alt="logo_google_maps" />
                        </a>
                      </div>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </Page>
      </>
    );
  }
}

// const mapStateToProps = ({ produtosGrupos, produtosGrupoSeparacao }) => ({ produtosGrupos, produtosGrupoSeparacao });
// export default connect(mapStateToProps)(ContentoresEmbalagensPage);
const mapStateToProps = ({ user }) => ({ user });

export default connect(mapStateToProps)(PrincipalPage);
